import { AxiosError } from 'axios';
import axios from 'utils/axios.config';
import { types, flow, Instance } from 'mobx-state-tree';
import { withAlertStore } from 'components/Core/CustomAlert/store';
import { ErrorData, IResponse } from 'types/common';
import { ReviewResponse, IModerateReviewRequest } from './types';

const { model, frozen, maybeNull } = types;

export const ReviewsStore = model('ReviewsStore', {
  reviews: maybeNull(frozen<ReviewResponse[]>()),
})
  .extend(withAlertStore)
  .actions((self) => ({
    setReviews(response: ReviewResponse[]) {
      self.reviews = response;
    },
  }))
  // GENERAL HANDLING
  .actions((self) => ({
    errorHandling({ response }: AxiosError<IResponse<ErrorData>>) {
      const msg = response ? response?.data.message || 'Internal server error' : 'Application error';
      self.alertStore.showAlert(msg);
      throw new Error(msg);
    },
  }))
  .actions((self) => ({
    getReviewsData: flow(function* () {
      yield axios
        .get('/review')
        .then((response) => self.setReviews(response.data.data || null))
        .catch(self.errorHandling);
    }),
    manageReview: flow(function* ({ id, moderation }: IModerateReviewRequest) {
      yield axios
        .patch(`review/${id}`, {
          isModeration: moderation,
        })
        .then(() => {
          const updatedReviews = self.reviews?.map((item) => (item.id === id ? { ...item, moderation } : item)) || [];
          self.setReviews(updatedReviews);
        })
        .catch(self.errorHandling);
    }),
    removeReview: flow(function* (id: string) {
      yield axios
        .delete(`review/${id}`)
        .then(() => {
          const updatedReviews = self.reviews?.filter((item) => item.id !== id) || [];
          self.setReviews(updatedReviews);
        })
        .catch(self.errorHandling);
    }),
  }));

export type IReviewsStore = Instance<typeof ReviewsStore>;
